<template>
  <div class="form-box" v-loading="loading">
    <el-container>
      <el-aside>
        <base-screen title="会员信息">
          <el-autocomplete
            type="text"
            class="inline-input"
            popper-class="my-autocomplete"
            v-model="param.parameter"
            placeholder="会员姓名/卡号/手机号"
            @select="handleSelectMember"
            :fetch-suggestions="querySearchMember">
            <template slot-scope="{ item }">
              <div class="name">会员姓名：{{ item.name }}</div>
              <div class="addr">会员卡号：{{ item.memberNo }}</div>
              <div class="addr">联系方式：{{ item.phone }}</div>
            </template>
          </el-autocomplete>
          <base-img class="img" :src="headImg" errType="headImg" width="100px"/>
          <div class="user-info" >
            <div>姓名：{{name}}</div>
            <div>性别：{{sex}}</div>
          </div>
          <div class="user-info">
            <div>会员卡号：{{memberNo}}</div>
            <div>会员生日：{{birthday}}</div>
          </div>
          <div class="user-info">
            <div>联系方式：{{phone}}</div>
            <div>账户余额：{{balanceMoney}}</div>
          </div>
        </base-screen>
      </el-aside>

      <el-main>
        <base-screen
          title="充值服务">
          <el-form
            :model="form"
            :rules="rules"
            :inline="true"
            class="demo-form-inline"
            ref="form"
            label-width="100px"
          >
            <el-form-item
              prop="amount"
              label="充值金额："
            >
              <el-input type="text" v-model="form.amount" placeholder="请输入充值金额"></el-input>
            </el-form-item>

            <el-form-item
              prop="chargeMode"
              label="支付方式："
            >
              <el-select v-model="form.chargeMode" clearable placeholder="请选择支付方式">
                <el-option
                  v-for="item in chargeModeOption"
                  :key="item.dictItemCode"
                  :label="item.dictItemName"
                  :value="item.dictItemCode"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              prop="remark"
              label="备注："
              class="ipt-textarea"
            >
              <el-input style="width: 400px" type="textarea" v-model="form.remark" placeholder="请填写备注" resize="none"></el-input>
            </el-form-item>
            <el-form-item>
              <div class="tc" style="text-align: center">
                <el-button
                  style="width: 140px"
                  type="primary"
                  v-pms="'recharge'"
                  @click="onSubmitRecharge">充值
                </el-button>
              </div>
            </el-form-item>
          </el-form>
        </base-screen>
        <div class="page-box">
          <el-form :inline="true" :model="tableParam" label-position="left"
                   class="demo-form-inline"
                   ref="screenForm"
                   @keydown.native.enter="searchSubmit"
                   @submit.native.prevent>
            <el-form-item label="充值时间：">
              <el-date-picker
                v-model="intervalData"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="支付方式：">
              <el-select v-model="tableParam.chargeMode" clearable placeholder="请选择支付方式">
                <el-option
                  v-for="item in chargeModeOption"
                  :key="item.dictItemCode"
                  :label="item.dictItemName"
                  :value="item.dictItemCode"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button class="btn-screen" type="primary" @click="searchSubmit">查询</el-button>
              <el-button type="text" @click="resetSearchSubmit">重置</el-button>
            </el-form-item>
          </el-form>
          <el-table
            :data="tableData"
            v-loading="tableDataLoading"
            border
            style="width: 100%">
            <el-table-column
              fixed
              prop="createTime"
              label="充值日期"
            >
            </el-table-column>
            <el-table-column
              prop="memberNo"
              label="会员卡号"
            >
            </el-table-column>
            <el-table-column
              prop="name"
              label="会员名称"
              width="100">
            </el-table-column>
            <el-table-column
              prop="amount"
              label="充值金额"
              width="80">
            </el-table-column>
            <el-table-column
              prop="chargeSource"
              label="支付渠道"
              :formatter="handleChargeSource"
              width="80">
            </el-table-column>
            <el-table-column
              prop="chargeMode"
              label="支付方式"
              :formatter="handleChargeMode"
              width="80">
            </el-table-column>
            <el-table-column
              prop="remark"
              label="备注"
            >
            </el-table-column>
            <el-table-column
              fixed="right"
              prop="chargeUser"
              label="操作人"
              width="100">
            </el-table-column>
          </el-table>
          <el-pagination
            class="pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page.pageNum"
            :page-sizes="[10, 15, 20]"
            :page-size="page.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="page.total">
          </el-pagination>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import {member, dict} from '../../api'
import {getSession} from '../../utils/session'
import {USER_ID, USER_NAME, ORG_CODE} from '../../constants'
import dayjs from 'dayjs'
import {plus} from 'number-precision'

export default {
  name: 'MemberRecharge',
  props: {
    memberId: String
  },
  mounted () {
    if (this.memberId) {
      this.getMember()
    }
    this.getChargeMode()
  },
  data () {
    let checkMoney = (rule, value, callback) => {
      if (value) {
        const reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/
        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的充值金额'))
        }
      } else {
        callback()
      }
    }
    return {
      loading: false,
      submitting: false,
      intervalData: [],
      tableDataLoading: false,
      headImg: '',
      balanceMoney: '',
      birthday: '',
      name: '',
      phone: '',
      sex: '',
      memberNo: '',
      tableData: [],
      memberNames: [],
      chargeModeOption: [],
      page: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pages: 0
      },
      tableParam: {
        orgCode: getSession(ORG_CODE),
        memberId: '',
        chargeType: '1',
        beginDate: '',
        endDate: '',
        chargeMode: ''
      },
      param: {
        parameter: ''
      },
      form: {
        orgCode: getSession(ORG_CODE),
        memberId: '',
        memberNo: '',
        chargeType: '1',
        chargeUser: getSession(USER_NAME),
        createUser: getSession(USER_ID),
        amount: '',
        chargeMode: '5',
        remark: ''
      },
      rules: {
        amount: [
          {required: true, message: '请填写充值金额', trigger: 'blur'},
          {validator: checkMoney, trigger: 'blur'}
        ],
        chargeMode: [
          {required: true, message: '请选择支付方式', trigger: 'change'}
        ]
      }
    }
  },
  components: {},
  watch: {
    intervalData (val) {
      let has = !!val && val.length > 0
      this.tableParam.beginDate = has ? dayjs(val[0]).format('YYYY-MM-DD') : ''
      this.tableParam.endDate = has ? dayjs(val[1]).format('YYYY-MM-DD') : ''
    },
    memberId (val) {
      this.memberId = val
      this.getMember()
    }
  },
  methods: {
    async getTableData () {
      this.tableDataLoading = true
      let {data, page} = await member.pageMemberRechargeLog({
        param: this.tableParam,
        page: this.page
      })
      this.tableDataLoading = false
      this.tableData = data
      this.page = page
    },
    async getMemberBalance () {
      let {data} = await member.getMemberBalance({
        memberId: this.tableParam.memberId,
        type: '0'
      })
      this.balanceMoney = data.balance
    },
    async getMember () {
      let {data} = await member.getMemberList({
        orgCode: getSession(ORG_CODE),
        parameter: ''
      })
      let obj = data.find(item => item.memberId === this.memberId)
      this.handleSelectMember(obj)
    },
    async getChargeMode () {
      let {data} = await dict.getDictList({
        dictTypeCode: 'CHARGE_MODE'
      })
      this.chargeModeOption = data
    },
    async querySearchMember (queryString, cb) {
      if (queryString) {
        let {data} = await member.getMemberList({
          orgCode: getSession(ORG_CODE),
          parameter: queryString
        })
        this.memberNames = data.filter(this.createChannelFilter(queryString))
      } else {
        this.memberNames = []
      }
      // 调用 callback 返回建议列表的数据
      cb(this.memberNames)
    },
    createChannelFilter (queryString) {
      return (member) => {
        return (member.name.toLowerCase().indexOf(queryString.toLowerCase()) > -1) ||
            (member.phone.indexOf(queryString.toLowerCase()) > -1) ||
            (member.memberNo.toLowerCase().indexOf(queryString.toLowerCase()) > -1)
      }
    },
    handleSelectMember (item) {
      this.param.parameter = item.name
      this.phone = item.phone.substr(0, 3) + '****' + item.phone.substr(7, 11)
      this.sex = item.sex === '1' ? ' 男' : ' 女'
      this.name = item.name
      this.birthday = item.birthday
      this.memberNo = item.memberNo
      this.headImg = item.headImg
      this.form.memberNo = item.memberNo
      this.form.memberId = item.memberId
      this.tableParam.memberId = item.memberId
      this.getMemberBalance()
      this.getTableData()
    },
    async onSubmitRecharge () {
      this.$confirm(`确定给会员：【${this.name}】充值么?`, '系统提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        callback: async (action, instance) => {
          if (action === 'confirm') {
            if (!this.form.memberId || !this.form.memberNo) {
              this.$message({
                type: 'error',
                message: '请先选择会员'
              })
              return
            }
            await this.$refs.form.validate()
            this.submitting = true
            this.loading = true
            let {code, msg} = await member.addMemberRechargeLog(this.form)
            this.submitting = false
            this.loading = false
            if (code === 0) {
              this.$message({
                type: 'success',
                message: msg || '充值成功'
              })
              this.getTableData()
              this.$bus.$emit('MemberRechargeManagement:getMemberBalance')
              this.balanceMoney = plus(this.balanceMoney.split('元')[0], this.form.amount) + '元'
              this.form.amount = ''
              this.form.chargeMode = '5'
              this.form.remark = ''
            } else {
              this.$message({
                type: 'error',
                message: msg || '充值失败'
              })
            }
          } else {
            this.$message({
              type: 'info',
              message: '取消充值'
            })
          }
        }
      })
    },
    searchSubmit () {
      if (!this.form.memberId || !this.form.memberNo) {
        this.$message({
          type: 'error',
          message: '请先选择会员'
        })
        return
      }
      this.page.pageNum = 1
      this.getTableData()
    },
    resetSearchSubmit () {
      if (!this.form.memberId || !this.form.memberNo) {
        this.$message({
          type: 'error',
          message: '请先选择会员'
        })
        return
      }
      this.$refs.screenForm.resetFields()
      this.intervalData = []
      this.tableParam.beginDate = ''
      this.tableParam.endDate = ''
      this.tableParam.chargeMode = ''
      this.getTableData()
    },
    handleChargeMode (row) {
      let result = this.chargeModeOption.find(item => item.dictItemCode === row.chargeMode)
      return result ? result.dictItemName : ''
    },
    handleChargeSource (row) {
      return row.chargeSource === '1' ? '线下' : '线上'
    },
    handleSizeChange (val) {
      this.page.pageSize = val
      this.getTableData()
    },
    handleCurrentChange (val) {
      this.page.pageNum = val
      this.getTableData()
    }
  }
}
</script>

<style lang="scss" scoped>
  .el-form {
    /*width: 570px;*/
    margin: 20px auto 0;
  }

  .el-col-2 {
    margin-left: 36px;
    width: 0.33333%;
  }

  .img {
    width:60px;
    height:60px;
    border-radius:50%;
    -webkit-border-radius:50%;
    -moz-border-radius:50%;
    display: block;
    margin-top: 15px;
  }

  .el-autocomplete,
  .inline-input {
    display: block;
  }

  .form-box {
    /deep/ .el-main {
      padding: 0 0 0 20px;
    }
    .page-box {
      border: none;
    }
    .el-aside {
      background-color: #fff;
    }
    .user-info {
      div {
        color: #666;
        font-size: 14px;
        margin-top: 10px;
      }
    }
    .el-date-editor {
      width: 290px;
    }
    /deep/.form-box {
      .page-box {
        .el-autocomplete {
          .el-input {
            width: 100%;
          }
        }
      }
    }
  }

</style>
